<template>
  <div class="ddzf-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-document" @click="orderSplitRecord">作废记录</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="上次操作时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="当前状态"
                    fixed="right"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===2" type="warning">待接单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===3" type="warning">售后处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===4" type="warning">技术评估</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===5" type="warning">拆单分配</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===6" type="warning">待拆单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===7" type="warning">订单确认</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===8" type="warning">待报价</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===9" type="warning">预付款</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===10" type="warning">工厂分派</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===11" type="warning">工厂接单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===12" type="warning">订单排产</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===13" type="warning">订单生产</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-document-delete" @click.stop="allot(scope.row)">立即作废</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单作废"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="作废原因" prop="rson">
          <el-input type="textarea" v-model="editForm.rson" show-word-limit maxlength="200"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, orderInvalid } from '@/api/erp'

export default {
  name: 'ddzf',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      editForm: {
        orderid: '',
        ordername: '',
        rson: ''
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        rson: [{ required: true, message: '请输入作废原因', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    orderSplitRecord() {
      this.$router.push({ path: '/work/order_obsolete_record' })
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: '2,3,4,5,6,7,8,9,10,11,12,13',
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    allot(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.rson = ''
      this.editVisible = true
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAllotOrder()
        } else {
          return false
        }
      })
    },
    SubAllotOrder() {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          remark: this.editForm.rson
        }
        orderInvalid(data).then(response => {
          this.$message({
            message: '订单已作废',
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ddzf-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 400px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 140px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 100px;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
            .record-box{
              position: absolute;
              width: 100px;
              height: 40px;
              line-height: 40px;
              right:0;
              top: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
